import { useState } from 'react';
import { Mail, Send } from 'lucide-react';
import { toast } from 'sonner';
import { useSelector } from 'react-redux';
import { CallAPIPostPromise } from 'Common/commaon';
import { getDecodeId } from 'slices/userProfile/thunk';
import { selectUserDetails } from 'slices/userProfile/reducer';

interface SendInviteFormProps {
  onInviteSent: (email: string) => void;
}

export function SendInviteForm({ onInviteSent }: SendInviteFormProps) {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const userDetails = useSelector(selectUserDetails);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);

    CallAPIPostPromise('/agent/invite-homeowner', {
      id: getDecodeId(),
      email,
      name: `${userDetails[0]?.user_first_name || ''} ${userDetails[0]?.user_last_name || ''}`.trim(),
    })
      .then(() => {
        toast.success('Invitation sent successfully');
        onInviteSent(email);
        setEmail('');
      })
      .catch((error) => {
        toast.error(error?.message || 'Unable to send the invitation');
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <section className="invite-form-card" aria-labelledby="invite-homeowner-title">
      <span className="invite-form-card__icon">
        <Mail aria-hidden="true" />
      </span>

      <h2 id="invite-homeowner-title">Send invitation</h2>
      <p>An email invitation will be sent through RELiBUILD.</p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="homeowner-invite-email">Email address</label>
        <input
          id="homeowner-invite-email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="homeowner@example.com"
          disabled={isSubmitting}
          required
        />

        <button type="submit" disabled={isSubmitting || !email}>
          {isSubmitting ? (
            <>
              <span className="spinner-border spinner-border-sm" aria-hidden="true" />
              Sending…
            </>
          ) : (
            <>
              <Send aria-hidden="true" />
              Send invite
            </>
          )}
        </button>
      </form>

      <small>The homeowner will receive a secure link to complete registration.</small>
    </section>
  );
}
